import React from 'react';
import styled, { css } from 'styled-components';
import { Flex, Box } from 'reflexbox';
import {
  Fab, Typography, Table, TableCell, TableRow, Tabs, Tab, RadioGroup,
  FormControlLabel, Card, TextField, Checkbox, Button, Paper, Select,
  Collapse,
} from '@material-ui/core';
import BackIcon from '@material-ui/icons/ArrowBackIos';
import { keyframes } from 'styled-components';
import { createMuiTheme } from '@material-ui/core/styles';
import KeyboardArrowRightRight from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowRightLeft from '@material-ui/icons/KeyboardArrowLeft';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { Link } from 'react-router-dom';
import IconArrow from './components/Icons/IconArrow';
import ReactSelect from 'react-select';

type StyleProps = {
  position?: string;
  colour?: string;
  right?: string;
  fontWeight?: string;
  fontweight?: string;
  fontstyle?: string;
  fontfamily?: string;
  border?: string;
  display?: string;
  $fontsize?: string;
  pt?: string;
  pr?: string;
  mr?: string;
  width?: string;
  height?: string;
  padding?: string;
  paddingTop?: string;
  paddingbottom?: string;
  borderleft?: string;
  bordertop?: string;
  borderBottom?: string;
  borderbottom?: string;
  fontSize?: string;
  cursor?: string;
  margin?: string;
  margintop?: string;
  $margintop?: string;
  marginright?: string;
  textAlign?: string;
  textalign?: string;
  align?: string;
  justify?: string;
  opacity?: string | number;
  float?: string;
  borderRadius?: string | number;
  editable?: boolean;
  buttoncolor?: string;
  texttransform?: string;
  hoverColor?: string;
  hoverButtonColor?: string;
  gap?: string;
};

export const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: '#EB6055',
    },
    secondary: {
      main: '#2F9D6D',
    },
  },
});

export const Autocomplete = styled(ReactSelect)`
  && {
    margin: 12px 8px 0 0;
    height: 43px;
    border-radius: 13px;
    box-shadow: 0 1px 2px 0 rgba(80, 80, 80, 0.2);
    background-color: #ffffff;
    font-size: 16px;
    padding: 0 12px;
    color: #257195;
    width: 400px;
    display: inline-block;
  }
  && > div {
    border: 0;
    margin-top: 1px;
    box-shadow: none;
  }

  && #react-select-2-option-0 {
    border-top: 2px solid #257195;
  }
`;

export const FlexBox = styled.div<StyleProps>`
  && {
    display: flex;
    justify-content: ${(props) => props.justify};
    gap: ${(props) => props.gap};
  }
`;

export const LineBreak = styled.hr`
  && {
    color: #c2c2c2;
  }
`;
export const Description = styled.div<{ padding?: string }>`
  && p {
    display: flex;
    justify-content: space-between;
    padding: ${(props) => (props.padding ? props.padding : `0`)};
  }
`;
export const ShadowContainer = styled.div`
  && {
    box-shadow: 0 2px 10px 4px rgba(0, 0, 0, 0.1);
    border: solid 1px #2f9d6d;
    border-radius: 20px;
    padding: 18px;
  }
`;
export const RadioCard = styled(RadioGroup)`
  && {
    padding: 0px 0px 16px 0px;
    margin: 42px 21px 0;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
  }
  && > label > span:first-child {
    display: none;
  }
`;
export const RadioCardItem = styled(FormControlLabel)<{ big?: boolean; tier?: string }>`
  && {
    width: 202px;
    margin-right: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${(props) => (props.big ? `305px` : `114px`)};
    border-radius: ${(props) => (props.big ? `27px` : `13px`)};
    border: solid 3px ${(props) => (props.checked ? `#2f9d6d` : `#b5b5b5`)};
    box-shadow: ${(props) => (props.checked ? `0 4px 8px 0 rgba(0, 0, 0, 0.19), 0 6px 15px 0 rgba(0, 0, 0, 0.17)` : '0px')};
    transition: transform 300ms ease-in-out;
    transform: ${(props) => (props.checked ? `translateY(-1.5px) scale(1.01,1.01)` : ``)};
  }
  && span {
    font-family: Assistant;
    font-weight: bold;
    font-size: ${(props) => (props.big ? `65px` : `25px`)};
    color: ${(props) => (props.checked ? `#2f9d6d` : `#b5b5b5`)};
  }
  &:after {
    content: ${(props) => (props.big ? `"${props.tier}"` : ``)};
    color: ${(props) => (props.checked ? `#2f9d6d` : `#b5b5b5`)};
    position: absolute;
    font-family: Assistant;
    font-weight: bold;
    font-size: 23px;
    top: 15px;
  }
  &:hover {
    transform: translateY(-1px) scale(1.02, 1.02);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19), 0 3px 7px 0 rgba(0, 0, 0, 0.17);
  }
`;
export const HeaderContainer = styled(Flex)<StyleProps>`
  && {
    padding: ${(props) => (props.padding ? props.padding : `0px`)};
    margin-left: 0px;
    margin-right: ${(props) => (props.marginright ? props.marginright : `16px`)};
    border-bottom: ${(props) => (props.borderbottom ? props.borderbottom : `solid 1px #e4e3e3`)};
  }
`;
export const Container = styled(Flex)`
  box-sizing: border-box;
  height: 100%;
  margin: 0 auto;
  max-width: 1200px;
  padding: 18px 0 16px;
`;
export const CardHeaderContainer = styled(Flex)`
  && {
    padding: 0px 0px 16px 0px;
    margin: 0;
    border-bottom: solid 1px #e4e3e3;
  }
`;
export const CardHeader = (props) => {
  return (
    <Flex>
      {props.icon && (
        <Box style={{ width: '50px' }}>
          <Icon src={props.icon} width={`30px`} alt="Icon" />
        </Box>
      )}
      <HeaderTitle padding={props.padding} style={{ width: 1 / 6 }}>
        {props.title}
      </HeaderTitle>
    </Flex>
  );
};

export const SubHeader = (props) => {
  return (
    <HeaderTitle {...props} padding={`50px 0 0 0`}>
      {props.title}
    </HeaderTitle>
  );
};

const ErrorMessage = styled.span`
  font-size: 13px;
  color: red;
  position: absolute;
  left: 0;
  bottom: 0;
`;

const LimitMessage = styled.span`
  font-size: 13px;
  color: #757575;
  position: absolute;
  right: 0;
  bottom: 0;
`;

export const InputField = ({ error, limit, ...props }: any) => (
  <div>
    <StyledTextField {...props} />
    <Collapse in={Boolean(error || limit)}>
      <div style={{ position: 'relative', height: '20px' }}>
        {limit && <LimitMessage>{props.value?.length} / {limit}</LimitMessage>}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
    </Collapse>
  </div>
);

export const StyledTextField = styled(TextField)<StyleProps>`
  && {
    width: 100%;
    margin-top: ${(props) => (props.margintop ? props.margintop : `0px`)};
  }
  && input[type='color'] {
    cursor: pointer;
  }
  && > p {
    color: #cf001c;
  }
  label[data-shrink="true"] {
    color: #757575;
  }
  && div::after {
    border-bottom: 2px solid #2f9d6d;
  }
`;
export const Field = (props) => {
  return <InputField {...props} />;
};

export const InsetField = styled(TextField)<StyleProps>`
  && {
    width: ${(props) => (props.width ? props.width : `40%`)};
    height: ${(props) => (props.height ? props.height : `auto`)};
    margin: ${(props) => (props.margin ? props.margin : `25px 10px 25px 10px`)};
  }
`;

export const IconButton = (props) => {
  return <Icon src={props.src} cursor={`pointer`} float={`right`} width={`150px`} padding={`45px 0 25px 0`} alt="One Icon" />;
};

export const CardContainer = styled(Card)<StyleProps>`
  && {
    width: ${(props) => (props.width ? props.width : `100%`)};
    height: ${(props) => (props.height ? props.height : `auto`)};
    opacity: ${(props) => (props.opacity ? props.opacity : `1`)};
    border-radius: 20px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    margin: ${(props) => (props.margin ? props.margin : `0 0 25px 0`)};
  }
`;
export const CardDetailsContainer = styled(Flex)`
  && {
    padding: 20px 0px 20px 0px;
    border-bottom: solid 1px #e4e3e3;
  }
`;
export const BounceAnimation = keyframes`
  0% { opacity:0;transform:translateX(30px);}
  100% { opacity:1;transform:translateX(0);}
`;
export const BounceAnimatedContainer = styled.div`
  && {
    animation: ${BounceAnimation} 0.4s ease-in-out forwards;
  }
`;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.9;
  }
`;

export const Name = styled(Typography)`
  && {
    cursor: pointer;
    color: #000000;
    font-family: Assistant;
    font-size: 17px;
    font-weight: 600;
  }
`;
export const UserRole = styled(Typography)`
  && {
    font-family: Assistant;
    font-size: 13px;
    font-weight: normal;
    color: #000000;
  }
`;

export const Avatar = styled.div``;
export const FabIcon = styled(Fab)`
  && {
    background: #2f9d6d;
    width: 38px;
    height: 38px;
  }
  & svg {
    color: #ffffff !important;
  }
`;
export const HeaderTitle = styled.div<StyleProps>`
  && {
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : `bold`)};
    width: ${(props) => (props.width ? props.width : `none`)};
    height: ${(props) => (props.height ? props.height : `none`)};
    padding: ${(props) => (props.padding ? props.padding : `0px`)};
    border-left: ${(props) => (props.borderleft ? props.borderleft : `none`)};
    border-bottom: ${(props) => (props.borderBottom ? props.borderBottom : `none`)};
    font-size: ${(props) => (props.fontSize ? props.fontSize : `none`)};
    cursor: ${(props) => (props.cursor ? props.cursor : `auto`)};
    color: ${(props) => (props.color ? props.color : `black`)};
    margin: ${(props) => (props.margin ? props.margin : `0`)};
    text-align: ${(props) => (props.textalign ? props.textalign : `left`)};
  }
  & > span {
    font-weight: normal;
  }
`;

export const Header = (props) => {
  return <HeaderTitle padding={`20px 0 20px 20px`}>{props.title}</HeaderTitle>;
};

export const AlignRight = styled(Box)`
  && {
    text-align: right;
  }
`;
export const IconContainer = styled(Box)`
  && {
    height: 30px;
  }
`;

export const MainTable = styled(Table)<{ marginbottom: string }>`
  && {
    width: ${(props) => (props.width ? props.width : `100%`)};
    margin-bottom: ${(props) => (props.marginbottom ? props.marginbottom : `0`)};
  }
`;
export const Row = styled(TableRow)`
  && {
    height: 66px;
    position: relative;
  }
`;
export const TableColumn = styled(TableCell)<StyleProps>`
  && {
    padding-left: 16px;
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : `normal`)};
    font-size: 16px;
    font-family: Assistant;
    color: ${(props) => (props.color ? props.color : `black`)};
    cursor: ${(props) => (props.cursor ? props.cursor : `auto`)};
  }
`;
export const Icon = styled.img<StyleProps>`
  && {
    width: ${(props) => (props.width ? props.width : `77px`)};
    height: ${(props) => (props.height ? props.height : `none`)};
    float: ${(props) => (props.float ? props.float : `none`)};
    padding: ${(props) => (props.padding ? props.padding : `0px`)};
    cursor: ${(props) => (props.cursor ? props.cursor : `auto`)};
    border-radius: ${(props) => (props.borderRadius ? props.borderRadius : `unset`)};
    margin: ${(props) => (props.margin ? props.margin : `0 0 0 10px`)};
  }
`;
export const TabHealthera = styled(Tab)`
  && {
    padding-top: 12px;
    width: 60px;
  }

  && span {
    margin-bottom: 4px;
    font-size: 14px;
    padding: 2px;
    color: ${(props) => (props.selected ? `#2f9d6d` : `black`)};
  }
`;

export const TabsContainer = styled(Box)`
  && {
    display: flex;
  }
  & > div > div > div > span {
    background-color: #2b9e6d;
    width: 100px;
  }
`;
export const TabButtons = styled(Tabs)<StyleProps>`
  && button {
    font-family: Assistant;
    text-transform: none;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '18px')};
    height: ${(props) => (props.height ? props.height : '72px')};
  }
  && {
    float: right;
  }
  && button[class^='MuiButtonBase-root-22 MuiTab-root-10 MuiTab-textColorInherit-12 MuiTab-selected-15'] {
    font-weight: bold;
    color: ${(props) => (props.color ? props.color : 'black')};
  }
`;
export const BackButton = styled(BackIcon)<StyleProps>`
  && {
    cursor: pointer;
    width: 15px;
    padding: ${(props) => (props.padding ? props.padding : `0`)};
  }
`;
export const LinkText = styled.span<StyleProps>`
  && {
    color: #2f9d6d;
    font-weight: 400;
    padding-left: 17px;
    cursor: pointer;
    padding-top: ${(props) => (props.pt ? props.pt : `0`)};
    position: ${(props) => (props.position ? props.position : `unset`)};
    right: ${(props) => (props.right ? props.right : `0`)};
  }
`;
export const FieldName = styled.p`
  && {
    font-weight: 600;
  }
`;
export const EditLink = styled(Box)<StyleProps>`
  && {
    width: 100%;
    color: #2f9d6d;
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '12px')};
    padding-right: 0px;
    padding-bottom: ${(props) => (props.paddingbottom ? props.paddingbottom : '0px')};
    float: ${(props) => (props.float ? props.float : '')};
    cursor: pointer;
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'normal')};
  }
`;

export const EditPlanButton = styled.span`
  && {
    position: unset;
    font-family: Assistant;
    background: none;
    border: 0;
    font-size: 16px;
    padding: 8px;
    margin: 0 5px;
    color: #2f9d6d;
    cursor: pointer;
  }
`;

export const RegisteredWithPlatformText = styled.span<StyleProps>`
  color: #2f9d6d;
  font-size: 15px;
  font-weight: bold;
  float: ${(props) => (props.float ? props.float : '')};
  padding: 12px 0;
`;

export const OrganisationSettingsHeader = styled.h4`
  margin: 0 0 10px 0;
`;

export const OrganisationSettingsToggleBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const OrganisationSettingsToggleHeader = styled.h4`
  margin: 5px 0;
`;

export const OrganisationPaymentOverdue = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const OrganisationSettingsBody = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const OrganisationSettingsInfo = styled.div`
  text-align: left;
`;

export const OrganisationSettingsToggleLabel = styled.span`
  float: left;
  padding: 12px 0;
`;
export const RegisteredWithPlatformTextLink = styled.a<StyleProps>`
  text-decoration: none;
  color: #2f9d6d;
  font-size: 15px;
  font-weight: bold;
  float: ${(props) => (props.float ? props.float : '')};
  padding: 12px 0;
`;

export const StripeIdCopyToClipboard = styled.div`
  font-size: 10px;
  cursor: pointer;
  &:hover {
    color: #666;
  }
`;

export const LinkButton = styled.span<StyleProps>`
  && {
    color: #2f9d6d;
    cursor: pointer;
    float: ${(props) => (props.float ? props.float : `right`)};
    padding-top: 30px;
    font-weight: 600;
  }
`;
export const MenuItems = styled(Box)`
  && {
    padding-right: 0px;
  }
  & > div > div > div > span {
    background-color: #2b9e6d;
  }
`;
export const MainTitle = styled.h1<StyleProps>`
  font-size: 18px;
  color: #212121;
  padding-right: 10px;
  cursor: ${(props) => (props.cursor ? props.cursor : `unset`)};
`;
export const Title = styled.p<StyleProps>`
  && {
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : `600`)};
    font-size: 24px;
    min-width: 105px;
    margin: ${(props) => (props.margin ? props.margin : `16px 0px 0px 0px`)};
    text-align: ${(props) => (props.textAlign ? props.textAlign : `right`)};
    padding: ${(props) => (props.padding ? props.padding : `0`)};
  }
`;
export const SearchContainer = styled.div`
  border-top: 1px solid #e7e7e7;
  height: 65px;
  display: flex;
  align-items: center;
`;
export const SearchBox = styled.div`
  && {
    font-family: Assistant;
    align-items: center;
    display: flex;
    color: #000000;
    width: 100%;
  }
  && svg,
  && input::placeholder,
  && input {
    color: #000000;
  }
`;
export const ButtonContainer = styled(Box)<StyleProps>`
  && {
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.justify ? props.justify : `flex-end`)};
    padding: ${(props) => (props.padding ? props.padding : `0`)};
  }
  && svg {
    color: #000000;
  }
`;
export const CloseButton = styled.img`
  && {
    padding-top: 20px;
    width: 30px;
    float: right;
    padding-right: 20px;
    cursor: pointer;
  }
`;
export const UnorderedList = styled.ul<StyleProps>`
  && {
    list-style-type: none;
    padding: ${(props) => (props.padding ? props.padding : `0`)};
    width: ${(props) => (props.width ? props.width : `auto`)};
    cursor: ${(props) => (props.cursor ? props.cursor : `unset`)};
  }
`;
export const List = styled.li`
  && {
    padding-bottom: 20px;
    color: ${(props) => (props.color ? props.color : `#000`)};
    border-bottom: #f6f6f6 solid 1px;
  }
`;
export const NotificationContainer = styled(Box)`
  && {
    overflow-y: auto;
    height: 490px;
  }
`;
export const NotificationsCard = styled.div`
  && {
    position: absolute;
    left: 64%;
    top: 19%;
    width: 365px;
    height: 600px;
    border-radius: 13px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
  }
`;
export const FullWidthBar = styled.div<StyleProps>`
  && {
    backdrop-filter: blur(8px);
    border-top: solid 8px #2f9d6d;
    background: #ffffff;
    height: ${(props) => (props.height ? props.height : `148px`)};
    padding: 0px 10px 0px 10px;
  }
`;
export const FullWidthBarShallow = (props) => {
  return <FullWidthBar {...props} height={`108px`}></FullWidthBar>;
};

export const HorizontalRule = styled.hr<StyleProps>`
  && {
    margin: ${(props) => (props.margin ? props.margin : `0`)};
    border: 0;
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
`;
export const CentredContainer = styled.div<StyleProps>`
  && {
    padding: ${(props) => (props.padding ? props.padding : `0`)};
    text-align: center;
  }
  && input::placeholder,
  && input {
    color: #000000;
    text-align: center;
    width: 450px;
    font-family: Assistant;
    font-size: 18px;
  }
  & p {
    font-family: Assistant;
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    color: #b5b5b5;
  }
`;
export const HealtheraButton = styled(Button)<StyleProps>`
  && {
    background-color: ${(props) => (props.disabled ? `#d4d4d4` : `#4DB181`)};
    color: ${(props) => (props.buttoncolor ? props.buttoncolor : `#fff`)};
    text-transform: ${(props) => (props.texttransform ? props.texttransform : `capitalize`)};
    font-size: ${(props) => (props.$fontsize ? props.$fontsize : `16px`)};
    font-weight: ${(props) => (props.fontweight ? props.fontweight : `600`)};
    font-style: ${(props) => (props.fontstyle ? props.fontstyle : `bold`)};
    font-family: ${(props) => props.fontfamily || ''};
    margin: ${(props) => (props.margin ? props.margin : `0`)};
    padding: ${(props) => (props.padding ? props.padding : `0px`)};
    width: ${(props) => (props.width ? props.width : `191px`)};
    height: ${(props) => (props.height ? props.height : `44px`)};
    border-radius: ${(props) => (props.borderRadius ? props.borderRadius : `5px`)};
    border: ${(props) => (props.border && props.disabled ? props.border : `none`)};
    display: ${(props) => (props.display ? props.display : ``)};
    opacity: ${(props) => (props.opacity ? props.opacity : '')};
    float: ${(props) => (props.float ? props.float : `none`)};
    cursor: ${(props) => (props.cursor ? props.cursor : `pointer`)};
    position: ${(props) => (props.position ? props.position : '')};

    &:hover {
      background-color: ${(props) => (props.hoverColor ? props.hoverColor : '#5eb88d')};
      color: ${(props) => (props.hoverButtonColor ? props.hoverButtonColor : '#fff')};
    }

    &[disabled] {
      color: white;
    }
  }
`;

export const DangerButton = styled(HealtheraButton)<StyleProps>`
  && {
    background-color: ${(props) => (props.disabled ? `#d4d4d4` : `#EB4D3D`)};
  
    &:hover {
      background-color: ${(props) => (props.hoverColor ? props.hoverColor : '#ea6559')};
    }
  }
`;

export const SecondaryButton = styled(Button)<StyleProps>`
  && {
    background-color: transparent;
    color: ${(props) => (props.buttoncolor ? props.buttoncolor : `#4DB181`)};
    text-transform: ${(props) => (props.texttransform ? props.texttransform : `capitalize`)};
    font-size: ${(props) => (props.$fontsize ? props.$fontsize : `16px`)};
    font-weight: ${(props) => (props.fontweight ? props.fontweight : `600`)};
    font-style: ${(props) => (props.fontstyle ? props.fontstyle : `bold`)};
    font-family: ${(props) => props.fontfamily || ''};
    margin: ${(props) => (props.margin ? props.margin : `0`)};
    padding: ${(props) => (props.padding ? props.padding : `0px`)};
    width: ${(props) => (props.width ? props.width : `191px`)};
    height: ${(props) => (props.height ? props.height : `44px`)};
    border-radius: ${(props) => (props.borderRadius ? props.borderRadius : `5px`)};
    border: ${(props) => (props.border && props.disabled ? props.border : `none`)};
    display: ${(props) => (props.display ? props.display : ``)};
    opacity: ${(props) => (props.opacity ? props.opacity : '')};
    float: ${(props) => (props.float ? props.float : `none`)};
    cursor: ${(props) => (props.cursor ? props.cursor : `pointer`)};
    position: ${(props) => (props.position ? props.position : '')};

    &:hover {
      background-color: ${(props) => (props.hoverColor ? props.hoverColor : 'rgba(77, 177, 129, .1)')};
    }

    &[disabled] {
      color: grey;
    }
  }
`;
export const ScrollBarWrapper = styled.div`
  && {
    text-align: center;
    width: 100%;
    margin: auto;
  }
`;
export const ScrollBar = styled.div`
  && {
    margin-left: 30px;
    max-height: 300px;
    width: 100%;
    overflow-y: scroll;
    margin-bottom: 25px;
  }
  &&::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: 25px 60px;
  }
  &&::-webkit-scrollbar {
    border-radius: 25px 60px;
    width: 3px;
    background-color: #2f9d6d;
  }
  &&::-webkit-scrollbar-thumb {
    border-radius: 25px 60px;
    background-color: #2f9d6d;
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
`;

export const Footer = styled.div<StyleProps>`
  && {
    position: absolute;
    right: 0;
    left: 0;
    width: 1200px;
    height: 70px;
    padding: ${(props) => (props.padding ? props.padding : `0px`)};
    border-top: ${(props) => (props.bordertop ? props.bordertop : `solid 1px #e4e3e3`)};
    display: flex;
    align-items: center;
  }
  && span {
    display: block;
    float: right;
    margin: auto;
    margin-right: ${(props) => (props.marginright ? props.marginright : `unset`)};
    font-size: 15px;
    color: #9c9c9c;
  }
  && span a {
    text-decoration: none;
    color: #212121;
  }
  && span:first-of-type {
    margin-left: 0;
  }
`;
export const PaperContainer = styled(Paper)<StyleProps>`
  && {
    padding: 20px;
    border-radius: 13px;
    margin-top: ${(props) => (props.$margintop ? [props.$margintop, 'px'].join('') : `unset`)};
  }
`;

export const TextButton = styled.span<StyleProps>`
  && {
    float: ${(props) => (props.float ? props.float : `none`)};
    color: ${(props) => (props.color ? props.color : `none`)};
    cursor: ${(props) => (props.cursor ? props.cursor : `pointer`)};
  }
`;
export const GreenCheckbox = styled(Checkbox)`
  && {
    color: #2f9d6d !important;
  }
`;
export const CenteredTextContainer = styled.div`
  && {
    width: 700px;
    height: 561px;
    margin: 0 50%;
  }
`;
export const ContainerRight = styled(Flex)`
  && {
    position: absolute;
    right: 0;
    padding-right: 8px;
    height: ${(props) => (props.height ? props.height : `unset`)};
  }
`;
export const ArrowRight = styled(KeyboardArrowRightRight)<StyleProps>`
  && {
    color: ${(props) => (props.colour ? props.colour : `#6E6E6E`)};
    cursor: ${(props) => (props.cursor ? props.cursor : `unset`)};
    padding: ${(props) => (props.padding ? props.padding : `0`)};
  }
`;
export const ArrowLeft = styled(KeyboardArrowRightLeft)`
  && {
    color: #2f9d6d;
    cursor: pointer;
    float: left;
    padding-top: 30px;
  }
`;

export const ErrorBox = styled.div`
  && {
    box-shadow: -4px 0 2px -2px rgba(0, 0, 0, 0.4);
    background: #287b56;
    color: white;
    margin: 32px 0;
    padding: 16px;
  }
`;

export const EmergencySelectedText = styled.b`
  && {
    font-weight: bold;
    color: #d0021b;
  }
`;
export const ArrowRightGreen = () => {
  return <ArrowRight colour={`#2f9d6d`} cursor={`pointer`} padding={`30px 0 0 0`} />;
};

export const Loading = (props) => {
  return (
    <div>
      <ScaleLoader css={"margin: '120px 0'; width: '1200px'; textAlign: 'center'"} radius={75} color={'#2f9d6d'} loading={props.loading} />
    </div>
  );
};

export const colors = {
  HEALTHERA_GREEN: '#2f9d6d',
  HEALTHERA_ORANGE: '#f8a64f',
  HEALTHERA_RED: '#d0021b',
  BLACK: '#212121',
  GRAY_DARKER: '#4a4a4a',
  GRAY_DARK: '#575757',
  GRAY: '#707070',
  GRAY_LIGHT: '#e0e0e0',
  GRAY_LIGHTER: '#f6f6f6',
  DARK: '#383847',
  FADED: '#8a8a8f',
  FADED_LIGHT: '#f9f9f9',
  BLUE: '#5273DB',
};

const STRIPE_ACCOUNT_STATUS_COLORS: Record<string, string> = {
  active: colors.HEALTHERA_GREEN,
  restricted: colors.HEALTHERA_RED,
  rejected: colors.HEALTHERA_RED,
  pending: colors.HEALTHERA_ORANGE,
};

export const StripeAccountStatusPill = styled.a<{ status?: string }>`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: bold;
  text-transform: capitalize;
  text-decoration: none;
  cursor: pointer;
  color: #fff;
  background-color: ${(props) => (props.status && STRIPE_ACCOUNT_STATUS_COLORS[props.status]) || colors.GRAY};
`;

export const ButtonReset = styled.button`
  appearance: none;
  background-color: transparent;
  border: none;
  font-family: inherit;
  padding: 0;

  &:focus {
    filter: drop-shadow(0 3px 6px ${colors.HEALTHERA_GREEN}99);
    outline: none;
  }

  &[disabled] {
    cursor: default;
  }
`;

export const ButtonArrow = styled(ButtonReset)<{ gray?: boolean }>`
  align-items: center;
  background-color: ${colors.HEALTHERA_GREEN};
  border: none;
  display: flex;
  fill: #fff;
  flex-direction: column;
  flex: 0 0 67px;
  justify-content: center;
  padding: 22px 0 18px;

  ${(props) =>
    props.gray &&
    css`
      background-color: ${colors.GRAY_LIGHTER};
      fill: ${colors.HEALTHERA_GREEN};
    `}

  span {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    transform: rotate(-90deg);
    white-space: nowrap;
    width: 0;
  }
`;

export const ButtonArrowIcon = styled(IconArrow)`
  height: 30px;
  margin-bottom: auto;
`;
export const CardCss = css`
  background-color: #ffffff;
  border-radius: 19px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  margin: 0 0 19px;
  overflow: hidden;
`;

export const Card2 = styled.div`
  ${CardCss}
`;

export const Separator = styled.div`
  background-color: #b5b5b5;
  height: 30px;
  margin: 0 20px;
  width: 1px;
`;

export const TabLink = styled(Link)`
  align-items: center;
  align-self: stretch;
  color: ${(props) => (props.active === 'true' ? colors.HEALTHERA_GREEN : colors.BLACK)};
  display: flex;
  font-size: 20px;
  font-weight: ${(props) => (props.active === 'true' ? 'bold' : 'normal')};
  letter-spacing: ${(props) => (props.active === 'true' ? '-0.4px' : '0.2px')};
  overflow: hidden;
  padding: 0 20px;
  position: relative;
  text-decoration: none;
  transition: color 0.3s ease-in-out;

  &:before {
    transition: transform 0.3s ease-in-out;
    background-color: ${colors.HEALTHERA_GREEN};
    transform: ${(props) => (props.active === 'true' ? 'translateY(0)' : 'translateY(100%)')};
    bottom: 0;
    content: '';
    height: 3px;
    left: 0;
    position: absolute;
    right: 0;
  }
`;
export const ColoredText = styled.div`
  && {
    color: ${(props) => (props.color ? props.color : 'black')};
  }
`;

export const BranchField = styled.div<StyleProps>`
  && {
    display: flex;
    line-height: 48px;
  }
  && > div:nth-child(1) {
    width: 75%;
  }
  && > div:nth-child(2) {
    width: 25%;
    text-align: right;
    margin-right: ${(props) => props.mr || '0px'};
    cursor: ${(props) => (props.editable ? 'pointer' : 'inital')};
  }
`;

export const DashboardSelectWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const IconWrapper = styled(ArrowDropDownIcon)<{ open?: boolean }>`
  transform: ${(props) => (props.open ? 'rotate(180deg)' : 'none')};
  transition: transform 1s ease-in-out;
`;

export const HeaderWithFilter = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const EmptyField = styled.div`
  text-align: center;
  &:after {
    content: '-';
  }
`;

export const PharmacyNameWrapper = styled.div`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const BoldTitle = styled.span`
   {
    font-weight: 600;
    padding: 0 10px 10px;
  }
`;

export const FloatRight = styled.span`
   {
    float: right;
  }
`;

export const DashboardSelect = styled(Select)`
  && {
    padding: 6px 16px;
    background-color: ${colors.FADED_LIGHT};
  }
`;

export const SpaceBetweenContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
